module.exports = __webpack_public_path__ + "img/manufacture-ala (1).2cfe295e.jpg";